import { FieldType } from "src/Common/Filters/interfaces/FiltersView";

export const PSFilterConfig = [{
    fieldId: 'ID',
    fieldName: 'ID',
    fieldType: FieldType.TextField,
    internalName: 'raidid',
    responseFormat: 'number'
  },
  {
    fieldId: 'Title',
    fieldName: 'Title',
    fieldType: FieldType.TextField,
    internalName: 'fields/title',
    responseFormat: 'string',
    isBulkEdit: true,
    bulkEditConfig: {
      fieldType: FieldType.TextField,
    },
  },
  {
    fieldId: 'ActionOwner',
    fieldName: 'Action Owner',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/assignedto/uniquename',
    responseFormat: 'string',
    isBulkEdit: true,
    bulkEditConfig: {
      fieldType: FieldType.PickerComponent,
    },
  },
  {
    fieldId: 'State',
    fieldName: 'State',
    fieldType: FieldType.Dropdown,
    fieldDropdownName: 'workItemStates',
    keyName: 'Name', 
    internalName: 'fields/state',
    responseFormat: 'string',
    isBulkEdit: true,
    bulkEditConfig: {
        fieldType: FieldType.Dropdown,
    },
  },
  {
    fieldId: 'SubState',
    fieldName: 'Sub State',
    fieldType: FieldType.Dropdown,
    fieldDropdownName: 'subStates',
    keyName: 'subState',
    internalName: 'fields/substate',
    responseFormat: 'string',
    isBulkEdit: true,
    bulkEditConfig: {
        fieldType: FieldType.Dropdown,
    },
  },
  {
    fieldId: 'Requestor',
    fieldName: 'Requestor',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/requestorsinfo/uniquename',
    responseFormat: 'arrayOfObjects'
  },
  {
    fieldId: 'RequestedDate',
    fieldName: 'Requested Date',
    fieldType: FieldType.DatePicker,
    internalName: 'fields/requesteddate',
    responseFormat: 'date'
  },
  {
    fieldId: 'rs_campaign',
    fieldName: 'Campaign',
    fieldType: 'Dropdown',
    fieldDropdownName: 'rS_campaign',
    keyName: 'displayName',
    internalName: 'fields/rs_campaign',
    responseFormat: 'string',
    isBulkEdit: true,
    bulkEditConfig: {
      fieldType: FieldType.Dropdown,
    },
  },
  {
    fieldId: 'rs_campaign_others',
    fieldName: 'Campaign Others',
    fieldType: 'TextField',
    internalName: 'fields/rs_campaign_others',
    responseFormat: 'string'
  },
  {
    fieldId: 'rs_subcampaign',
    fieldName: 'Sub Campaign',
    fieldType: 'TextField',
    internalName: 'fields/rs_subcampaign',
    responseFormat: 'string',
    isBulkEdit: true,
    bulkEditConfig: {
      fieldType: FieldType.TextField,
    },
  },
  {
    fieldId: 'rs_requesttype',
    fieldName: 'Request Type',
    fieldType: 'Dropdown',
    internalName: 'fields/rs_requesttype',
    responseFormat: 'string',
    fieldDropdownName: 'rS_requesttype',
    keyName: 'displayName',
    isBulkEdit: true,
    bulkEditConfig: {
      fieldType: FieldType.Dropdown,
    },
  },
  {
    fieldId: 'rs_partnertype',
    fieldName: 'Partner Type',
    fieldType: 'Dropdown',
    internalName: 'fields/rs_partnertype',
    responseFormat: 'string',
    fieldDropdownName: 'rS_partnertype',
    keyName: 'displayName'
  },
  {
    fieldId: 'rs_partneroneid',
    fieldName: 'Partner One ID',
    fieldType: 'TextField',
    internalName: 'fields/rs_partneroneid',
    responseFormat: 'string'
  },
  {
    fieldId: 'rs_partnername',
    fieldName: 'Partner Name',
    fieldType: 'TextField',
    internalName: 'fields/rs_partnername',
    responseFormat: 'string'
  },
  {
    fieldId: 'rs_partnercountry',
    fieldName: 'Partner Country',
    fieldType: 'TextField',
    internalName: 'fields/rs_partnercountry',
    responseFormat: 'string'
  },
  {
    fieldId: 'rs_partnerregion',
    fieldName: 'Partner Region',
    fieldType: 'TextField',
    internalName: 'fields/rs_partnerregion',
    responseFormat: 'string'
  },
  {
    fieldId: 'rs_partnercountry1',
    fieldName: 'Partner Country 1',
    fieldType: 'Dropdown',
    internalName: 'fields/rs_partnercountry1',
    responseFormat: 'string',
    fieldDropdownName: 'rS_partnercountry1',
    keyName: 'partnerCountry'
  },
  {
    fieldId: 'rs_partnerregion1',
    fieldName: 'Partner Region 1',
    fieldType: 'Dropdown',
    internalName: 'fields/rs_partnerregion1',
    responseFormat: 'string',
    fieldDropdownName: 'CoSellPartnerRegion',
    keyName: 'partnerRegion'
  },
  {
    fieldId: 'rs_pdmname',
    fieldName: 'PDM Name',
    fieldType: 'PickerComponent',
    internalName: 'fields/rs_pdmname/uniquename',
    responseFormat: 'string'
  },
  {
    fieldId: 'rs_deliverylanguage',
    fieldName: 'Delivery Language',
    fieldType: 'Dropdown',
    internalName: 'fields/rs_deliverylanguage',
    responseFormat: 'string',
    fieldDropdownName: 'rS_deliverylanguage',
    keyName: 'displayName'
  },
  {
    fieldId: 'rs_skillingplanstatus',
    fieldName: 'Skilling Plan Status',
    fieldType: 'Dropdown',
    internalName: 'fields/rs_skillingplanstatus',
    responseFormat: 'string',
    fieldDropdownName: 'rS_skillingplanstatus',
    keyName: 'displayName',
    isBulkEdit: true,
    bulkEditConfig: {
      fieldType: FieldType.Dropdown,
    },
  },
  {
    fieldId: 'rs_skillingplanattachment',
    fieldName: 'Skilling Plan Attachment',
    fieldType: 'Dropdown',
    internalName: 'fields/rs_skillingplanattachment',
    responseFormat: 'string',
    fieldDropdownName: 'yesOrNo',
    keyName: 'yesOrNo'
  },
  {
    fieldId: 'rs_partnercontactname',
    fieldName: 'Partner Contact Name',
    fieldType: 'TextField',
    internalName: 'fields/rs_partnercontactname',
    responseFormat: 'string'
  },
  {
    fieldId: 'rs_partneremail',
    fieldName: 'Partner Email',
    fieldType: 'TextField',
    internalName: 'fields/rs_partneremail',
    responseFormat: 'string'
  }
]